import I18n from 'i18n-js'
import storage from 'services/storage'
import en from './locales/en'
import he from './locales/he'
import store, {setLanguage} from 'store/Store'

I18n.fallbacks = true
I18n.translations = {
    he,
    en,
}

export const getSupportedLanguages = () => Object.keys(I18n.translations)

export const setLocale = (lang) => {
    store.dispatch(setLanguage(lang))

    if (I18n.locale === lang) return
    I18n.locale = lang
    if (lang === 'he') {
        storage.setLanguage('he')
    } else {
        storage.setLanguage('en')
    }
}

let activeLanguage = storage.getLanguage()
if (!activeLanguage) {
    storage.setLanguage('he')
    activeLanguage = 'he'
}

setLocale(activeLanguage)

export default I18n
